import { Button } from "@mui/material"
import noop from "lib/noop"
import { useDarkMode } from "lib/use-dark-mode"

/**
 * A styled Mui button with theme info colors, useful for in info severity alerts.
 *
 * @param {string} text - The text printed inside the button.
 * @param {function} onClick - The function to run when the button is clicked.
 * @returns A pre styled Mui Button.
 */
export function ErrorButton({ text, onClick = noop, sx, ...props }) {
    const isdark = useDarkMode()
    return (
        <Button
            sx={{
                color: isdark ? "error.lighter" : "error.darker",
                borderColor: isdark ? "error.lighter" : "error.darker",
                "&:hover": {
                    borderColor: isdark ? "error.lighter" : "error.darker",
                    backgroundColor: "#0A3A6614",
                },
                ...sx,
            }}
            variant="outlined"
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}
